// import

import {styled} from 'goober';
import type {ComponentProps} from 'react';

import {Link} from 'modules/Link';

// types

type Props = ComponentProps<typeof Nav> & {
  page: number;
  last: number;
};

// vars

const maxNums = 5;

// fns

const getLink = (page: number, last: number) => (
  page <= 1 ? '/blog' :
  page >= last ? `/blog/${last}` :
  `/blog/${page}`
);

const getNums = (page: number, last: number) =>
  Array.from({length: maxNums}, (_, i) => page + i - 2)
    .filter((n) => n >= 1 && n <= last);

// component

export function Pagination(props: Props) {
  const {page, last, ...rest} = props;
  const nums = getNums(page, last);

  return (
    <Nav {...rest}>
      {page === 1 ? (
        <div className="arrow" />
      ) : (
        <Link
          aria-label="Previous blog page"
          className="arrow left"
          href={getLink(page - 1, last)}
        >
          ←
        </Link>
      )}

      {nums.map((n) => (
        n === page ? (
          <div
            key={n}
            aria-label={`Current blog page ${n}`}
            className="num active"
          >
            {n}
          </div>
        ) : (
          <Link
            key={n}
            aria-label={`Blog page ${n}`}
            className="num"
            href={getLink(n, last)}
          >
            {n}
          </Link>
        )
      ))}

      {page === last ? (
        <div className="arrow" />
      ) : (
        <Link
          aria-label="Next blog page"
          className="arrow right"
          href={getLink(page + 1, last)}
        >
          →
        </Link>
      )}
    </Nav>
  );
}

// styles

const Nav = styled('nav')`
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  font-size: 1rem;
  user-select: none;

  .num, .arrow {
    flex: 0 0 auto;
    padding: 0 1rem;
    min-width: 2.5rem;
    border-radius: 0.5rem;
    font-weight: 400;
    text-align: center;
  }

  a {
    transition: color 100ms ease-in-out, background 100ms ease-in-out;

    &:hover {
      color: var(--white);
      background: var(--red);
    }
  }

  .active {
    /* color: var(--white); */
    background: var(--yellow);
  }
`;
